module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sortBy":"Sort by","newest":"Newest","oldest":"Oldest","recommended":"Recommended"},"de":{"sortBy":"Sortieren nach","newest":"Neueste","oldest":"Älteste","recommended":"Empfohlen"}}')
  delete Component.options._Ctor
}
